import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IUserProfile, UserApiService } from 'shared';

@Injectable({ providedIn: 'root' })
export class UserService {
    private readonly userApi = inject(UserApiService);

    public getProfile(): Observable<IUserProfile> {
        return this.userApi.getProfile();
    }

    public updateProfile(userId: string, language: string, emailAddress: string): Observable<IUserProfile> {
        return this.userApi.putProfile(userId, { language, emailAddress });
    }
}
